import { render } from "./Currency.vue?vue&type=template&id=3c67d88d&ts=true"
import script from "./Currency.vue?vue&type=script&lang=ts"
export * from "./Currency.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__